/**
* @author XuZiYu
* @date 2019/8/30
* @time 09:53
*/
<template>
  <div class="not-open-warp">
    <div v-if="!$route.query.shareType && $route.query.headShow !== '0'" class="header"
         :style="{'padding-top':headHeight + 'px'}">
      <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1@2x.png" alt=""/></div>
      <div class="header-main">VIP题库</div>
      <div class="header-share" v-if="this.isShowShareIcon" @click="openSharePanel"><img src="@/assets/public/icon_fx01.png"
                                                                                         alt=""></div>
      <div class="header-right" @click="callPhone"><img src="@/assets/vip/icon_customerservice1@2x.png" alt=""></div>
    </div>
    <div v-if="!$route.query.shareType  && $route.query.headShow !== '0'" class="header-pre"
         :style="{'padding-top':headHeight + 'px'}"></div>
    <share-ad :detail="adInfo">
      <div class="bg">
        <img src="@/assets/vip/picture_01@2x.png" alt=""/>
        <img src="@/assets/vip/picture_02@2x.png" alt=""/>
        <img src="@/assets/vip/picture_03@2x.png" alt=""/>
      </div>
      <div class="rule">
        <div class="rule-title">
          <img class="rule-icon-left" src="@/assets/vip/icon_line1@2x.png" alt=""/>
          <span>服务说明</span>
          <img class="rule-icon-right" src="@/assets/vip/icon_line2@2x.png" alt=""/>
        </div>
        <p class="rule-content">1. VIP题库，有效期为<b>{{vipData.effectiveDays}}天</b>，购买后即刻生效。
          2. VIP题库为虚拟产品，不支持退款，请知悉后再购买。
          3. VIP题库不包含不过包赔的保障险，费用仅包含题库包。
          4. 如有疑问，请联系{{vipData.phone}}。</p>
      </div>
      <div class="rule">
        <div class="rule-title">
          <img class="rule-icon-left" src="@/assets/vip/icon_line1@2x.png" alt=""/>
          <span>使用说明</span>
          <img class="rule-icon-right" src="@/assets/vip/icon_line2@2x.png" alt=""/>
        </div>
        <p class="rule-content">1.购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。<br>2.如有疑问或需要帮助，请联系平台客服咨询。</p>
      </div>
    </share-ad>
    <div class="footer-pre"></div>
    <div class="footer">
            <span v-if="vipData.openMode === 1" class="second">
                限时领取 <b>（分享激活）</b>
            </span>
      <span v-else class="first">
                <b v-if="vipData.openMode === 3" class="top">{{vipData.pointNum}}斑豆</b>
                <b v-if="vipData.openMode === 2" class="top">¥{{vipData.payConPrice > 0 ? vipData.payConPrice : vipData.payOrigPrice}}{{vipData.payConPoint ? ` + ${vipData.payConPoint}斑豆` : ''}}</b>
                <b v-if="vipData.openMode === 2 && vipData.payConPrice > 0"
                   class="bottom">原价¥{{vipData.payOrigPrice}}</b>
            </span>
      <template v-if="Number(carType) === 1">
        <van-button v-if="isIOS" class="recovery" @click="submit" :loading="loading">恢复购买</van-button>
        <van-button class="fourth" @click="submit" :loading="loading">立即开通</van-button>
      </template>
      <template v-else>
        <div class="btn-none-buy">仅适用于C1/C2学员</div>
      </template>
    </div>
    <ctl-dialog v-model="dialogData" :dialogStyle="dialogStyle" :loading="loading">
      <div slot="content" class="password-input">
        <ul @click="clickInput">
          <li v-for="v in 6" :key="v">{{value[v - 1]}}</li>
        </ul>
        <input ref="input" type="text" v-model="value" maxlength="6"/>
      </div>
    </ctl-dialog>
    <ctl-dialog v-model="messageDialog" :dialogStyle="dialogStyle" :loading="loading"/>
  </div>
</template>

<script>
import dialog from '@/components/dialog'
import { Toast, Button } from 'vant'

export default {
    name: 'notOpen',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button
    },
    props: ['vipData', 'userInfo', 'uploadAppFlag'],
    methods: {
        // 返回
        goBack () {
            window.app.returnLastPage && window.app.returnLastPage()
        },
        // 拨打客服电话
        callPhone () {
            if (this.isGoApp()) {
                return
            }
            window.app.pushCusService && window.app.pushCusService()
        },
        // 打开分享面板
        openSharePanel () {
            window.app.share && window.app.share(this.adInfo.shareTitle || 'VIP题库', '掌握一题=练习多题，轻松搞定科一&科四！', this.adInfo.shareType === '1' ? location.href.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn') + '&shareType=h5' + `&appType=${window.app.getAppType && window.app.getAppType()}` : '', this.adInfo.shareType === '1' ? (this.adInfo.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png') : this.adInfo.shareGroupImg, 'question-bank')
        },
        // 点击输入框事件
        clickInput () {
            this.$refs.input.focus()
        },
        isGoApp () {
            // 判断是否h5
            if (this.$route.query.shareType === 'h5') {
                let isIos = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                if (isIos) {
                    if (navigator.userAgent.toLowerCase().match(/QQ/i) == 'qq') {
                        let body = document.querySelectorAll('body')[0]
                        let div = document.createElement('div')
                        let img = document.createElement('img')
                        div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                        div.onclick = () => {
                            body.removeChild(div)
                        }
                        img.src = require('@/assets/public/icon_fxts.png')
                        img.style = 'width:100%'
                        div.appendChild(img)
                        body.appendChild(div)
                        return
                    }
                    if (Number(this.$route.query.appType) === 2) {
                        location.href = 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    } else {
                        location.href = 'https://share.banbanjiadao.com/ui/h5/bb/index'
                    }
                } else {
                    if (Number(this.$route.query.appType) === 2) {
                        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    } else {
                        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
                    }
                }
                return true
            }
            return false
        },
        // 开通
        submit () {
            if (this.isGoApp()) {
                return
            }

            if (!this.isIOS && !this.userInfo.userId) {
                window.app.loginUser && window.app.loginUser()
                return
            }

            if (this.uploadAppFlag) {
                Toast.fail('VIP服务已升级，请升级APP获取更多服务！')
                return
            }

            let currentUserId = this.userInfo.userId
            // 班豆支付
            if (this.vipData.openMode === 3) {
                // 没有用户id && 去登录
                if (!this.userInfo.userId) {
                    window.app.loginUser && window.app.loginUser()
                    return
                }
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '确认',
                    leftBtnName: '取消',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.loading = true
                        this.$api.bbBeanOpen({ currentUserId: currentUserId }).then(res => {
                            this.loading = false
                            if (res.result === null && res.status) {
                                this.$emit('refresh')
                            } else if (res.message.indexOf('斑豆不足') > -1) {
                                this.messageDialog = {
                                    visible: true,
                                    rightBtnName: '去做任务',
                                    leftBtnName: '取消',
                                    leftBtnMethod: () => {
                                        this.messageDialog.visible = false
                                    },
                                    rightBtnMethod: () => {
                                        window.app.pushBandouCenterPage && window.app.pushBandouCenterPage()
                                    },
                                    title: '',
                                    content: res.message
                                }
                            } else if (res.code !== '666') {
                                Toast.fail(res.message)
                            }
                        })
                    },
                    title: '',
                    content: '是否确认开通VIP题库？'
                }
            }
            // 金钱支付
            if (this.vipData.openMode === 2) {
                let data = {}
                data.currentUserId = currentUserId
                if (window.app.getAppVersion) {
                    data.version = window.app.getAppVersion()
                }
                let open = () => {
                    this.loading = true
                    this.$api.vipPayOpen(data).then(res => {
                        this.loading = false
                        if (res.code === '200' && res.status) {
                            // 判断是否IOS && 苹果支付
                            if (this.isIOS) {
                                window.app.applyPay && window.app.applyPay(res.result, this.vipData.productId)
                            } else {
                                this.$router.push({
                                    name: 'pay',
                                    query: {
                                        payId: res.result,
                                        money: this.vipData.payConPrice > 0 ? this.vipData.payConPrice : this.vipData.payOrigPrice,
                                        type: '1',
                                        headShow: this.$route.query.headShow || '1'
                                    }
                                })
                            }
                        } else if (res.code === '701') {
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去支付',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.$router.push({
                                        name: 'vipOrderDetail',
                                        query: { id: res.result, headShow: '1' }
                                    })
                                },
                                title: '',
                                content: '您有VIP订单未支付'
                            }
                        } else if (res.code !== '666') {
                            Toast.fail(res.message)
                        }
                    })
                }

                // 判断是否购买过弹出提示
                if (this.isBuy) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '恢复购买',
                        rightBtnMethod: () => {
                            this.resetBuy()
                        },
                        onWrap: () => {
                            this.messageDialog.visible = false
                        },
                        title: '',
                        content: '您的设备已开通VIP服务，请勿重复购买'
                    }
                    return
                } else {
                    open()
                }
            }
            // 分享激活
            if (this.vipData.openMode === 1) {
                // 没有用户id && 去登录
                if (!this.userInfo.userId) {
                    window.app.loginUser && window.app.loginUser()
                    return
                }
                window.app.share && window.app.share(this.vipData.title, this.vipData.content, this.vipData.link, this.vipData.image, 'question-bank')
            }
        },
        // 支付回调
        payCallback (v) {
            if ((Number(v) === 1) && (!this.userInfo.userId)) {
                this.$emit('refresh')
                return
            }

            if (this.userInfo.userId) {
                // 跳转支付结果页
                this.$router.push({ name: 'payResult', query: { result: v, headShow: '1' } })
            }
        },
        // 分享回调
        shareCallback () {
            // 判断是否小车
            if (Number(this.carType) !== 1) {
                return
            }

            // 判断是否分享 && 回调
            if (Number(this.vipData.openMode) !== 1) {
                return
            }
            this.loading = true
            this.$api.vipShareOpen({ shareRecordId: this.vipData.shareRecordId, times: '1' }).then(res => {
                this.loading = false
                if (res.status) {
                    if (res.result === 0) {
                        this.$emit('refresh')
                    } else {
                        Toast.success('分享成功')
                    }
                }
            })
        },
        // 打开
        openCode () {
            // 没有用户id && 去登录
            if (!this.userInfo.userId) {
                window.app.loginUser && window.app.loginUser()
                return
            }
            this.dialogData = {
                visible: true,
                rightBtnName: '立即激活',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.dialogData.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.$api.activeCodeOpen({ activeCode: this.value }).then(res => {
                        this.loading = false
                        if (res.result === null && res.status) {
                            this.$emit('refresh')
                        } else if (res.result) {
                            Toast.fail(res.result)
                        } else if (res.code !== '666') {
                            Toast.fail(res.message)
                        }
                    })
                },
                title: '输入6位',
                content: ''
            }
        },
        resetBuy () {
            let data = {}
            data.currentUserId = this.userInfo.userId
            data.recoveryBuyFlag = true
            if (window.app.getAppVersion) {
                data.version = window.app.getAppVersion()
            }
            this.loading = true
            this.$api.vipPayOpen(data).then(res => {
                this.loading = false
                if (res.result) {
                    window.app.appleRestore({
                        prodct: this.vipData.productId,
                        order: res.result
                    })
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 恢复购买回调
        didPaySuccess () {
            // 跳转支付结果页
            this.$emit('refresh')
        },
        // 是否购买过回调
        didPay (v) {
            this.loading = false
            if (Number(v) === 1) {
                this.isBuy = true
            }
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.adInfo = res.result
                    this.isShowShareIcon = this.$route.query.shareType !== 'h5' && window.app.shareParams
                }
            })
        }
    },
    mounted () {
        this.getSetting()

        if (this.isIOS && this.vipData.payConPoint) {
            this.$nextTick(() => {
                document.querySelectorAll('.top')[0].style.fontSize = '15px'
                document.querySelectorAll('.bottom')[0].style.fontSize = '14px'
            })
        }
    },
    created () {
        if (window.app.getBankCarType) {
            // 设置车型
            this.carType = window.app.getBankCarType()
        } else {
            // 设置车型
            this.carType = window.app.getCarType ? window.app.getCarType() : '1'
        }
        // 暴露支付回调方法
        window.payCallback = this.payCallback
        // 暴露分享回调方法
        window.shareCallback = this.shareCallback
        // 暴露恢复购买回调方法
        window.didPaySuccess = this.didPaySuccess
        // 暴露是否购买过回调方法
        window.didPay = this.didPay
    },
    data () {
        return {
            carType: '1',
            dialogStyle: { marginBottom: '' },
            value: '',
            loading: false,
            isResetBuy: false,
            isBuy: false,
            isShowShareIcon: false,
            headHeight: 0,
            adInfo: {},
            isIOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  @function vw($px) {
    @return ($px / 750) * 100vw;
  }

  .not-open-warp {
    .reset-buy {
      position: fixed;
      height: 40px !important;
      bottom: 65px;
      right: 5px;
      border-radius: 10px;
      color: #A86F2F;
    }

    .van-button {
      height: 100%;
      border: none;
    }

    .van-button__loading {
      margin: 0 auto;
      vertical-align: middle;
    }

    .header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      background: #ffffff;

      .header-main {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: bold;
        color: #333333;
      }

      .header-share {
        position: absolute;
        height: 60px;
        display: flex;
        align-items: center;
        right: 50px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
        }
      }

      .header-left, .header-right {
        display: flex;
        padding: 15px 10px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .header-pre {
      height: 60px;
    }

    background: #FAFAFA;

    .password-input {
      position: relative;
      margin-top: 20px;

      input {
        opacity: 0;
        height: 100px;
        width: 100px;
        border: none;
        position: absolute;
        left: -100%;
      }

      ul {
        text-align: center;

        li {
          vertical-align: top;
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          border: 1px solid #cccccc;
          font-size: 24px;
          font-family: PingFangSC;
          font-weight: 600;
          color: #333333;

          & + li {
            border-left: none;
          }
        }
      }
    }

    .bg {
      line-height: 1;
      font-size: 0;

      img {
        width: 375px;
      }
    }

    .rule {
      margin-bottom: 10px;

      .rule-title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: 15px;
        font-family: PingFangSC;
        font-weight: 600;
        padding: 15px 0;

        span {
          margin: 0 20px;
        }

        img {
          width: 15px;
        }
      }

      .rule-content {
        padding: 0 15px;
        font-size: 13px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        word-break: break-word;
        white-space: pre-line;

        b {
          color: #FF5050;
          font-weight: normal;
        }
      }
    }

    .footer-pre {
      height: 49px;
    }

    .footer {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 49px;
      border-top: 1px solid #EEEEEE;
      background: #ffffff;
      display: flex;
      justify-content: space-between;

      span {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .first {
        flex-direction: column;
        flex: 1;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(255, 80, 80, 1);

        .top {
          color: #FF5050;
          font-size: 18px;
        }

        .bottom {
          color: #999999;
          font-size: 14px;
          text-decoration: line-through;
        }
      }

      .second {
        flex: 1;
        font-size: 17px;
        font-family: PingFangSC;
        font-weight: bold;
        color: #333333;

        b {
          font-size: 13px;
          font-weight: normal;
        }
      }

      .third {
        width: 80px;
        background: #FFEED2;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: bold;
        color: #D4A36B;
      }

      .fourth {
        border-radius: 0;
        width: 110px;
        background: #F5DDB6;
        font-size: 17px;
        font-family: PingFangSC;
        font-weight: bold;
        color: #A86F2F;
      }

      .recovery {
        border-right: 1px solid #fff;
        border-radius: 0;
        width: 110px;
        background: #F5DDB6;
        font-size: 17px;
        font-family: PingFangSC;
        font-weight: bold;
        color: #A86F2F;
      }
    }
    .btn-none-buy{
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 15px;
      font-weight: bold;
      color: #999999;
      background: #F0F0F0;
    }
  }
</style>
